<template>
  <g>
    <path
      d="M14.27 6.00024C13.72 6.95024 14.05 8.18024 15 8.73024C15.95 9.28024 17.18 8.95024 17.73 8.00024C18.28 7.05024 17.95 5.82024 17 5.27024C16.05 4.72024 14.82 5.05024 14.27 6.00024Z"
    />
    <path
      d="M15.84 10.4102C15.84 10.4102 14.21 9.47025 13.24 8.91025C11.11 7.67025 10.23 5.08025 11.06 2.84025C11.23 2.38025 11.05 1.87025 10.63 1.63025C10.1 1.33025 9.40998 1.56025 9.19998 2.13025C8.24998 4.64025 8.84998 7.48025 10.66 9.40025L6.00998 17.4502C5.72998 17.9302 5.89998 18.5402 6.37998 18.8202C6.85998 19.1002 7.46998 18.9302 7.74998 18.4502L8.74998 16.7202L10.48 17.7202L7.97998 22.0502C7.69998 22.5302 7.86998 23.1402 8.34998 23.4202C8.82998 23.7002 9.43998 23.5302 9.71998 23.0502L15.51 13.0302C16.49 14.3702 16.77 16.1502 16.17 17.7502C16 18.2002 16.19 18.7102 16.6 18.9502C17.13 19.2602 17.82 19.0302 18.04 18.4502C19.01 15.8302 18.45 12.6102 15.84 10.4102Z"
    />
    <path
      d="M12.75 3.80025C13.47 4.21025 14.38 3.97025 14.8 3.25025C15.21 2.53025 14.97 1.62025 14.25 1.20025C13.53 0.790246 12.62 1.03025 12.2 1.75025C11.79 2.47025 12.03 3.39025 12.75 3.80025Z"
    />
  </g>
</template>
